import {createListViewColumns, initKendoGrid} from "./ListViewColumns";
import {areEqual, getFirstNotEmptyObj, isAnyEqualToFirst, isNotEmptyOrNull, registerOnWindowResize} from "../../common/NamaCommon";
import * as ts from "../../common/Translator";
import {getListViewTitle, isArabic, translateTitledId} from "../../common/Translator";
import * as bf from "../../constants/BusinessFunction";
import {userCan, userCanCreate} from "../../login/Security";
import * as CapabilityType from '../../constants/CapabilityType'
import ListScreenTemplate from "../../compiled-templates/ListScreenTemplate";
import {constructMoreActionsMenu} from "../edit/MoreActionsMenu";
import {of} from "../../widgets/ActionPlaceholder";
import * as GenericActions from "../../constants/GenericActions";
import * as BSCEntities from "../../constants/BSCEntities";
import {isReplicateOptions} from "../../routing/NestMode";
import * as BSEntities from "../../constants/BSEntities";
import {MoreMenuItem} from "../../views/edit/MoreMenuItem";
import * as ConstantViewNames from "../../constants/ConstantViewNames";
import {separator} from "../edit/MoreMenuItem";
import * as CommonConstants from "../../constants/CommonConstants";
import {CriteriaEditorWidget} from "./CriteriaEditorWidget";
import {CriteriaExpressionSerializer} from "../../common/CriteriaAndQuestionsURLParser";
import * as OutputFormat from "../../constants/OutputFormat";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import * as metadata from "../../common/Metadata";
import {TreeViewImpl} from "../treeView/TreeViewImpl";
import {TreeViewForListView} from "../treeView/TreeViewForListView";
import {ListViewSortByBar} from "./ListViewSortByBar";
import {NamaRouterInstance} from "../../routing/NamaRouter";
import {NamaKendoWindow} from "../NamaKendoWindow";
import ResultSettingsTemplate from "../../compiled-templates/ResultSettingsTemplate";
import {getEntityCustomReports, getMenuLineBySrc, isDocument} from "../../login/ClientCache";
import {CustomReportLauncherMenuItem} from "../edit/CustomReportLauncherMenuItem";
import * as ShowCustomRepIn from "../../constants/ShowCustomRepIn";
import {printForm} from "../../common/NaMaPrinting";
import {CriteriaAndQuestionsOverrider} from "./CriteriaAndQuestionsOverrider";
import {ApprovalAndNotificationOverrider} from "./ApprovalAndNotificationOverrider";
import {MultiApproveDialog} from "./MultiApproveDialog";
import {approveCase} from "../../widgets/ApprovalsAndNotifications";
import {isMobileDevice} from "../../common/GUIUtilities";
import {entitiesWithLedgerEffects, scCostDocs, scLedgerDocs} from "../../constants/EntitiesWithLedgerEffectsOrWithParents";
import {getColWidth, setColWidth} from "../StorageUtil";
import * as DomainBaseEntities from "../../constants/DomainBaseEntities";
import * as notifier from "../../common/ErrorsNotification";
import ReportExportDialogTemplate from "../../compiled-templates/ReportExportDialogTemplate";
import {ReferenceWidget} from "../../widgets/ReferenceWidget";
import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";
import * as ExpressionRelationship from "../../constants/ExpressionRelationship";
import {calcBtnTitle} from "../edit/EditScreenToolbar";
import {initGoToHome} from "../Navbar";
import * as entities from "../../constants/EntitiesWithLedgerEffectsOrWithParents";

let gridId = "#gridAllVoice";

/**
 * @extends NamaGridOwner
 */
export class ListScreenView {
    /**
     *
     * @param {ListPresenter} presenter
     */
    constructor(presenter) {
        let that = this;
        that.presenter = presenter;
        that.metaData = presenter.metaData;
        that.overrider = that.getListViewOverrider(presenter.entityType, presenter.place.listViewName);
    }

    render() {
        let that = this;
        let presenter = that.presenter;
        let place = presenter.place;
        let title = getListViewTitle(presenter.entityType, place.listViewName, presenter.preferences.listLayout, getMenuLineBySrc(place.src));
        that.title = title;
        let containerDiv = $(ListScreenTemplate({
            entityType: title,
            translateId: ts.translateId,
        }));
        if (presenter.block)
            containerDiv.find(".page-top-header-name").remove();
        that._createDisplayColumns();
        that.rootElement = containerDiv;
        that.rootElement.find(gridId).data("namaGrid", that);
        that._initKendoToolbar();
        that.toolBarItemsActions();
        that.initCriteriaWidget();
        new ListViewSortByBar(presenter, that.rootElement).render();
        if (isArabic()) {
            that.rootElement.find("#splitter").addClass("k-rtl");
            that.rootElement.find(gridId).addClass("k-rtl");
        } else {
            that.rootElement.find("#splitter").removeClass("k-rtl");
            that.rootElement.find(gridId).removeClass("k-rtl");
        }
        initKendoGrid(this, "", gridId);
        that.rootElement.on("click", "#approveCurrent", (e) => {
            let grid = that.rootElement.find(gridId).data("kendoGrid");
            let row = $(e.target).closest("tr");
            let dataItem = grid.dataItem(row);
            let apCaseId = dataItem.values["apcase.id"];
            approveCase(apCaseId);
        });
        return containerDiv;
    }

    autoFitLocalStorageKey() {
        let that = this;
        let presenter = that.presenter;
        let place = presenter.place;
        return presenter.entityType + place.listViewName + "autoFitColsApplied";
    }

    layoutPrefix() {
        return "list";
    }

    place_() {
        return this.presenter.place;
    }

    toolBar_() {
        return this.rootElement.find(".toolbar");
    }

    getListViewOverrider(entityType, listViewName) {
        let that = this;
        if (areEqual(entityType, BSEntities.ApprovalDefinition)
            && isAnyEqualToFirst(listViewName, ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME,
                ConstantViewNames.EMPLOYEE_READ_NOTIFICATIONS_SCREEN_NAME))
            return new ApprovalAndNotificationOverrider(that.presenter);
        return new CriteriaAndQuestionsOverrider(that.presenter);
    }

    overrideCriteria(criteria) {
        return this.overrider.overrideCriteria(criteria);
    }

    overrideQuestionFields(questionFields, source) {
        return this.overrider.overrideQuestionFields(questionFields, source);
    }

    initCriteriaWidget() {
        let that = this;
        let oldCriteria = null;
        let layoutId = that.presenter.preferences.listLayout.id;
        let cachedCriteria = metadata.getCachedCriteria(that.presenter.entityType, layoutId);
        if (cachedCriteria && cachedCriteria.expressions && cachedCriteria.expressions.length) {
            if (that.presenter.preferences.listLayout.defaultCriteria) {
                let criteriaFromStr = JSCriteriaBuilder.criteriaFromStr(cachedCriteria);
                cachedCriteria = criteriaFromStr.addDefaultCriteria(that.presenter.preferences.listLayout.defaultCriteria);
            }
            cachedCriteria = that.overrideCriteria(cachedCriteria);
            oldCriteria = cachedCriteria;
            let cachedQuestionFields = metadata.getCachedQuestionFields(that.presenter.entityType, layoutId);
            cachedQuestionFields = that.overrideQuestionFields(cachedQuestionFields, []);
            that.filledQuestionFields = cachedQuestionFields;
        } else {
            oldCriteria = new CriteriaExpressionSerializer().criteriaFromURL(this.presenter.place.criteria);
        }
        that.oldCriteria = oldCriteria;
        let criteriaFields = that.presenter.preferences.listLayout.criteriaFields;
        if (criteriaFields && criteriaFields.length) {
            that.criteriaWidget = new CriteriaEditorWidget({
                rootElement: that.rootElement,
                presenter: that.presenter,
                oldCriteria,
                metadata: that.presenter.metaData,
                entityType: that.presenter.entityType,
                criteriaFields: criteriaFields,
                owner: that
            });
            that.criteriaWidget.render();
        }
    }

    criteriaWidget_() {
        return this.criteriaWidget;
    }

    splitterDiv() {
        return this.rootElement.find("#splitter");
    }

    initTreeView(forceDrawTree, openTree) {
        let that = this;
        if (that.presenter.place.currentRoot)
            openTree = true;
        if (forceDrawTree || that.presenter.hasTree() || that.presenter.place.currentRoot) {
            let treeViewForListView = new TreeViewForListView(that.presenter.entityType);
            let treeViewImpl = new TreeViewImpl(treeViewForListView.getTreeModelProviderForListView(),
                treeViewForListView.getHelperForListView(), that.presenter, () => that.presenter.onListView());
            that.presenter.treeView = treeViewImpl;
            treeViewImpl.drawTreeView(that, openTree);
        }
    }

    initSplitter() {
        let that = this;
        that.initTreeView();
        let splitterDiv = that.rootElement.find("#splitter");
        if (!splitterDiv.data("kendoSplitter")) {
            let treeWidth = "250px";
            if (isMobileDevice())
                treeWidth = "150px";
            that.splitterDiv().kendoSplitter({
                panes: [
                    {collapsible: false},
                    {collapsible: true, size: treeWidth, collapsed: true},
                ]
            }).data("kendoSplitter");
        } else {
            splitterDiv.data("kendoSplitter").toggle(".k-pane:last");
        }
    }

    calcPageSize() {
        let psize = this.presenter.place.pageSize;
        if ("all".toLocaleLowerCase() === psize)
            psize = 0;
        if (psize < 0)
            psize = 0;
        return psize;
    }

    calcCurrentPage() {
        let page = parseInt(this.presenter.place.currentPage) || 0;
        return page + 1;
    }

    /**
     *
     * @returns {kendo.ui.Grid}
     */
    kendoGrid() {
        return this.rootElement.find(gridId).data("kendoGrid");
    }

    refresh() {
        this.kendoGrid().dataSource.read();
    }

    toolBarItemsActions() {
        let that = this;
        let presenter = that.presenter;
        let toolbar = that.rootElement.find(".toolbar");
        let buttons = toolbar.find("a[role=button]");
        if (buttons.length) {
            for (let i = 0; i < buttons.length; i++) {
                let current = $(buttons[i]);
                if (current.attr("data-business-func"))
                    current.attr('title', calcBtnTitle(current.attr("data-business-func")));
            }
        }
        toolbar.find("#newRecord").click(() => presenter.onNewRecord());
        toolbar.find("#listView").click(() => presenter.onListView());
        toolbar.find("#printBtn").click(() => presenter.onPrint(OutputFormat.PDF));
        toolbar.find("#showResultSettings").click(() => that.showResultSettingsWindow());
        toolbar.find("#reviseBtn").click(() => presenter.revise(this.getSelectedRowsId()));
        toolbar.find("#unReviseBtn").click(() => presenter.unRevise(this.getSelectedRowsId()));
        toolbar.find("#deleteBtn").click(() => that.deleteAction());
        toolbar.find("#treeViewBtn").click(() => that.showTreeView());
        toolbar.find("#exportcsv").click(() => that.exportToExcel());
        toolbar.find("#autoFitCols").click(() => that.autoFitGridColumns());
        toolbar.find("#moreMenu").click(() => that.showMoreMenu());
        toolbar.find("#refreshBtn").click(() => presenter.onRefresh());
        toolbar.find("#export").click(() => showExportDialog(that.presenter));
        toolbar.find("#listViewName").click(() => that.showViewNamesDialog());
        initGoToHome(toolbar.find("#homeBtn"));
    }

    showViewNamesDialog() {
        let that = this;
        let viewNames = that.presenter.viewNames;
        if (!viewNames)
            return;
        if (viewNames.length == 1)
            return;
        let panelBar = $(`<div class="w-100"></div>`);
        let window = new NamaKendoWindow(ts.translateId("listViewName"));
        if (isMobileDevice()) {
            window.width = "50%";
            window.height = "50%";
        } else {
            window.width = "30%";
            window.height = "30%";
        }
        window.content.append(panelBar);
        window.showWindow(() => {
            panelBar.kendoPanelBar({
                loadOnDemand: false,
                select: function (e) {
                    let dataItem = panelBar.data("kendoPanelBar").dataItem(e.item);
                    that.presenter.setViewName(dataItem.value);
                    window.closeWindow();
                },
                dataTextField: "text",
                dataSource: {
                    data: viewNames,
                    serverFiltering: true,
                },
            });
            let index = viewNames.findIndex(n => n.value == that.presenter.viewName_());
            if (index < 0)
                index = viewNames.findIndex(n => n.value == "default");
            panelBar.data("kendoPanelBar").select(`li:eq(${index})`);
        });
    }

    deleteAction() {
        let that = this;
        that.presenter.bulkDeleteEntities(that.getSelectedRowsId());
        that.dataSource.read();
    }

    showMoreMenu() {
        let that = this;
        let moreMenuButtons = this.getListViewMoreMenuItems();
        constructMoreActionsMenu(that.presenter, moreMenuButtons)
    }

    changeFilteringIcon(hasExpressions) {
        let that = this;
        let filteringBtn = that.rootElement.find(".toolbar").find("#toggleFilterAndSort");
        let filterIcon = filteringBtn.children(".k-icon");
        if (hasExpressions) {
            filterIcon.removeClass("k-i-filter-clear");
            filterIcon.addClass("k-i-filter");
            filteringBtn.addClass("k-active");
        } else {
            filterIcon.removeClass("k-i-filter");
            filterIcon.addClass("k-i-filter-clear");
            filteringBtn.removeClass("k-active");
        }
    }

    toggleFilterAndSortAction() {
        let that = this;
        that.rootElement.find(".b-filter").slideToggle(700, () => that.setHeightOfListViewGrid());
    }

    _initKendoToolbar() {
        let that = this;
        let rootElement = that.rootElement;
        let presenter = that.presenter;
        rootElement.find(".tab-strip, .tab-strip-add").kendoTabStrip({
            animation: {
                open: {
                    effects: "fadeIn"
                }
            }
        });
        if (!that.presenter.wrapperHeight) {
            let heightOfQuickIcons = rootElement.find(".tabs .quick-icons-one-invoice").innerHeight();
            let heightOfTabs = rootElement.find(".tabs .k-tabstrip-items-wrapper").innerHeight();
            let widthOfContentTitle = rootElement.find(".tabs .title h5").innerWidth();
            let widthOfContentTitle_add = rootElement.find(".tabs .tab-strip-add .title h5").innerWidth();
            let heightOfTitle = rootElement.find(".tabs .title").innerHeight();
            let mq = window.matchMedia("(max-width: 768px)");
            if (mq.matches) {
                rootElement.find(".tabs .quick-icons-one-invoice").css("margin-top", heightOfTabs + heightOfTitle);
                rootElement.find(".tabs .k-tabstrip-items-wrapper").css("margin-bottom", heightOfQuickIcons);
            } else {
                rootElement.find(".tabs .quick-icons-one-invoice").css("margin-top", heightOfTabs);
                rootElement.find(".tabs .k-tabstrip-items-wrapper").css({
                    "margin-bottom": heightOfQuickIcons,
                    "margin-right": widthOfContentTitle + 22,
                });
                rootElement.find(".tabs .tab-strip-add .k-tabstrip-items-wrapper").css({
                    "margin-bottom": heightOfQuickIcons,
                    "margin-right": widthOfContentTitle_add + 22,
                });
                rootElement.find(".tabs .title").css("height", heightOfTabs);
            }
        }
        let toolbar = rootElement.find(".toolbar");
        preValidateListScreenToolbarButtons(this, toolbar, presenter);
        toolbar.find("span").css("font-size", "20px");
    }

    autoFitGridColumns() {
        let that = this;
        let grid = that.kendoGrid();
        let options = $.extend({}, grid.getOptions());
        for (let i = 0; i < grid.columns.length; i++) {
            let gridColumn = grid.columns[i];
            if (gridColumn.selectable && gridColumn.locked)
                continue;
            grid.autoFitColumn(i);
            setColWidth(that, {column: {id: gridColumn.id}, newWidth: gridColumn.width});
            options.columns[i].width = gridColumn.width;
            if (gridColumn.width > 400)
                options.columns[i].width = 400;
        }
        localStorage.setItem(that.autoFitLocalStorageKey(), "true");
        localStorage.setItem((that.autoFitLocalStorageKey() + "AutoFitApplied"), "true");
        grid.setOptions(options);
    }

    showTreeView() {
        let that = this;
        that.presenter.place.showTree = !that.presenter.isShowingTree();
        NamaRouterInstance.updateHistoryURLSilently(that.presenter.place);
        that.initTreeView(undefined, true);
    }

    /**
     *
     * @param {Array} moreMenuButtons
     */
    getListLayoutExtraMoreMenuItems(moreMenuButtons) {
        let presenter = this.presenter;
        let ownerId = presenter.preferences.metaData.owner.ownerId;
        if (ownerId === BSEntities.ApprovalDefinition && presenter.preferences.listLayout.id === ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME) {
            moreMenuButtons.push(new MoreMenuItem("approveSelectedLines", presenter, () => {
                let flatObjects = presenter.view.getSelectedRows();
                let entityTypes = [];
                let entityIds = [];
                let nextStepSequences = [];
                for (let fieldValue of flatObjects) {
                    let id = fieldValue.values["approvedElement"].id;
                    if (entityIds.contains(id))
                        continue;
                    entityTypes.push(fieldValue.values["approvedElement"].entityType);
                    entityIds.push(id);
                    nextStepSequences.push(fieldValue.values["nextStepSequence"]);
                }
                new MultiApproveDialog(presenter, entityTypes, entityIds, nextStepSequences).showPopup();
            }));
        }
        moreMenuButtons.push(separator(presenter));
        let entityCustomReports = getEntityCustomReports(presenter.metaData.owner.ownerId);
        if (entityCustomReports) {
            for (let customRepInfo of entityCustomReports) {
                if (customRepInfo.showIn === ShowCustomRepIn.ListViewMore)
                    moreMenuButtons.push(new CustomReportLauncherMenuItem(presenter, customRepInfo));
            }
        }
        return moreMenuButtons;
    }

    /**
     *
     * @param {Array} moreMenuButtons
     */
    getListLayoutStandardMoreMenuItems(moreActions) {
        let presenter = this.presenter;
        moreActions.push(of(GenericActions.DELETE_SELECTED));
        moreActions.push(of(GenericActions.CREATE_LIST_VIEW_CRITERIA));
        moreActions.push(of(CommonConstants.MORE_MENU_SEPERATOR));
        if (userCan(presenter.entityType, CapabilityType.Import))
            moreActions.push(of(GenericActions.IMPORT_RECORDS));
        if (userCan(presenter.entityType, CapabilityType.Export)) {
            moreActions.push(of(GenericActions.EXPORT_SELECTED));
            moreActions.push(of(GenericActions.EXPORT_PAGE));
            moreActions.push(of(GenericActions.EXPORT_ALL));
        }
        moreActions.push(of(GenericActions.SAVE_DRAFT_RECORDS));
        moreActions.push(of(GenericActions.PREVENT_USAGE));
        moreActions.push(of(GenericActions.ALLOW_USAGE));
        if (userCan(BSCEntities.ScreenModifier, CapabilityType.EditAfterCommit))
            moreActions.push(of(GenericActions.OPEN_SCREEN_MODIFIER_FOR_LIST_VIEW));
    }

    /**
     *
     * @returns {Array}
     */
    getListViewMoreMenuItems() {
        let that = this;
        let presenter = that.presenter;
        if (!userCan(presenter.entityType, CapabilityType.CanViewMoreMenu))
            return [];
        let moreActions = [];
        let moreMenuButtons = [];
        let listLayout = presenter.preferences.listLayout;
        if (listLayout) {
            if (listLayout.moreActions) {
                for (let moreAction of listLayout.moreActions) {
                    let item = of(moreAction.id);
                    item.setTitle(moreAction.title);
                    item.setCustomization(moreAction.customization);
                    moreActions.push(item);
                }
            }
            moreMenuButtons.push(new MoreMenuItem("cancelColumnsAutoFit", presenter, () => {
                localStorage.setItem(that.autoFitLocalStorageKey(), "false");
                let options = $.extend({}, that.kendoGrid().getOptions());
                for (let c of options.columns) {
                    let displayColumn = listLayout.displayColumns.filter(col => col.id === c.id)[0];
                    if (displayColumn)
                        c.width = getFirstNotEmptyObj(getColWidth(presenter, displayColumn.id), displayColumn.width, '10em');
                }
                that.kendoGrid().setOptions(options);
            }));
            moreActions.push(of(CommonConstants.MORE_MENU_SEPERATOR));
            if (!listLayout.hideEntitySpecificFeatures) {
                this.getListLayoutStandardMoreMenuItems(moreActions);
                if (isReplicateOptions()) {
                    moreActions.push(of(GenericActions.RECOMMIT));
                    if (entitiesWithLedgerEffects.contains(presenter.entityType) || scCostDocs.contains(presenter.entityType) || scLedgerDocs.contains(presenter.entityType))
                        moreActions.push(of(GenericActions.REGEN_ACCOUNTING_EFFECTS));
                    if (isDocument(presenter.entityType))
                        moreActions.push(of(GenericActions.REGEN_INVENTORY_EFFECTS));
                    moreActions.push(of(GenericActions.REVERT_TO_PREVIOUS_VERSION));
                    if (presenter.entityType === BSEntities.ReportDefinition)
                        moreActions.push(of("updateSystemReports"));
                    if (isAnyEqualToFirst(presenter.entityType, ...entities.HAS_ACTIVATED_ENTITIES))
                        moreActions.push(of("cancelActivated"));
                }
                moreActions.push(of(GenericActions.LIST_VIEW_ADD_TO_CURRENT_USER_FAVOURITES));
                moreActions.push(of(GenericActions.ADD_SELECTED_DOCS_TO_LINES_OF_CURRENT_USER_FAVOURITE));
            }
            moreMenuButtons.push(separator(presenter));
            if (moreActions.length > 0) {
                for (let moreAction of moreActions) {
                    if (moreAction.shouldBeAdded()) {
                        let actionId = moreAction.id;
                        if (actionId === CommonConstants.MORE_MENU_SEPERATOR) {
                            moreMenuButtons.push(separator(presenter));
                        } else {
                            let moreMenuItem = new MoreMenuItem(actionId, presenter, null, null, moreAction.subItems, moreAction.customization);
                            if (isNotEmptyOrNull(moreAction.title))
                                moreMenuItem.title = translateTitledId(null, moreAction);
                            moreMenuButtons.push(moreMenuItem);
                        }
                    }
                }
            }
            if (isReplicateOptions()) {
                if (presenter.entityType === BSEntities.ReportDefinition) {
                    //TODO:
                    //moreMenuButtons.push(RemoteObjectImporter.openImplRepo());

                }

                let currentEntityType = presenter.entityType;
                if (listLayout.queriedClass) {
                    currentEntityType = listLayout.queriedClass.split(".").pop();
                }
                moreMenuButtons.push(new MoreMenuItem("showEntityDM", presenter, () => {
                    window.open("https://www.namasoft.com/dm/#entity:entity/" + currentEntityType + "&", "_blank");
                }));
            }
            if (!listLayout.hideEntitySpecificFeatures) {
                moreMenuButtons.push(new MoreMenuItem("printSelectedRows", presenter, () => {
                    presenter.onPrint(OutputFormat.PDF);
                }));
                moreMenuButtons.push(new MoreMenuItem("printSelectedRowsUsingEditForm", presenter, () => {
                    let listIds = presenter.view.getSelectedRowsId();
                    for (let id of listIds) {
                        printForm(presenter.entityType, id, {resourceId: "main"}, OutputFormat.PDF, presenter.viewName_(), 0, presenter.place.src);
                    }
                }));
            }
            return this.getListLayoutExtraMoreMenuItems(moreMenuButtons);
        }
    }

    getViewRowsId() {
        let grid = this.kendoGrid();
        let viewRows = grid.dataSource.view();
        let ids = [];
        if (!viewRows)
            return ids;
        for (let row of viewRows.items) {
            if (ids.indexOf(row.id) === -1)
                ids.push(row.id);
        }
        return ids;
    }

    getSelectedRowsId() {
        let grid = this.kendoGrid();
        let id = [];
        grid.select().each(function () {
            let rowData = grid.dataItem(this);
            if (id.indexOf(rowData.values.id) === -1)
                id.push(rowData.values.id);
        });
        return id;
    }

    getSelectedRowsEntityTypes() {
        let grid = this.kendoGrid();
        let entityTypes = [];
        grid.select().each(function () {
            let rowData = grid.dataItem(this);
            entityTypes.push(rowData.values.entityType);
        });
        return entityTypes;
    }

    getSelectedRows() {
        let grid = this.kendoGrid();
        let rows = [];
        grid.select().each(function () {
            let rowData = grid.dataItem(this);
            if (rows.filter(r => r.uid === rowData.uid).length == 0)
                rows.push(rowData);
        });
        return rows;
    }

    enableToolbarBtn(btnId) {
        this.rootElement.find("#" + btnId).removeClass("k-disabled");
    }

    disableToolbarBtn(btnId) {
        this.rootElement.find("#" + btnId).addClass("k-disabled");
    }

    get pageSize() {
        return this.kendoGrid().dataSource.pageSize() || 25;
    }

    get currentPage() {
        return this.kendoGrid().dataSource.page() || 1;
    }

    onDataFetched(data) {

    }

    readFromServer(options) {
        this.presenter.fetchFromServer(options);
    }

    _createDisplayColumns() {
        let that = this;
        that.model = {};
        let layoutDisplayColumns = that.presenter.preferences.listLayout.displayColumns;
        let cachedDisplayColumns = that.presenter.getDisplayColumns();
        if (cachedDisplayColumns) {
            for (let i = layoutDisplayColumns.length - 1; i >= 0; i--) {
                if (!cachedDisplayColumns.contains(layoutDisplayColumns[i].id))
                    layoutDisplayColumns[i].displayed = false;
                else
                    layoutDisplayColumns[i].displayed = true;
            }
        }
        that.displayColumns = createListViewColumns(that, {displayColumns: layoutDisplayColumns}, that.model);
    }

    afterAttach() {
        let that = this;
        that.initSplitter();
        registerOnWindowResize(this.rootElement[0], (e) => {
            that.setHeightOfListViewGrid();
        });
        setTimeout(() => this.setHeightOfListViewGrid(), 100);
        that.rootElement.find(".filter").click(function () {
            that.toggleFilterAndSortAction();
        });
        let alwaysShowFilterPart = localStorage.getItem("alwaysShowFilterPart");
        if (alwaysShowFilterPart == "true")
            that.toggleFilterAndSortAction();
        let criteriaBottom = that.rootElement;
        let conditionsGroup = criteriaBottom.find("#conditionsGroup");
        conditionsGroup.kendoButtonGroup({
            items: [
                {text: ts.translateId("AllConditions")},
                {text: ts.translateId("AnyCondition")}

            ],
            select: function (e) {
                that.presenter.onListView();
            }
        });
        let showAlways = criteriaBottom.find("#showSearch");
        let extraCriteriaWidget = new ReferenceWidget({
            owner: {
                rootElement: that.rootElement,
                entityType: that.entityType,
                owner: that.owner,
                onDataChanged: (id, ref) => {
                    that.presenter.place.extraCriteria = ref ? ref.id : null;
                    that.presenter.onListView();
                },
            },
            fieldMetadata: {fieldId: "extraCriteria", referencedEntityType: BSEntities.CriteriaDefinition},
            width: 20,
            placeholder: translateId("extraCriteria")
        });
        that.presenter.extraCriteriaWidget = extraCriteriaWidget;
        extraCriteriaWidget.extraCriteria = new JSCriteriaBuilder().field(DomainBaseFieldIDs.CriteriaDefinition_forType).equal(that.presenter.entityType).and()
            .field(DomainBaseFieldIDs.CriteriaDefinition_useInList).equal("true").build();
        extraCriteriaWidget.render().appendTo(criteriaBottom.find("#extraCriteriaContainer").find(".widgetContainer"));
        extraCriteriaWidget.afterAttach();
        showAlways.prop('checked', localStorage.getItem("alwaysShowFilterPart") === "true");
        showAlways.click(() => {
            localStorage.setItem("alwaysShowFilterPart", showAlways.prop("checked"));
        });
        let condGroupData = conditionsGroup.data("kendoButtonGroup");
        if (that.oldCriteria.expressions && that.oldCriteria.expressions.length) {
            let relation = that.oldCriteria.expressions[0].relation;
            if (relation == ExpressionRelationship.AND) {
                condGroupData.select(0);
            } else {
                condGroupData.select(1);
            }
        } else {
            condGroupData.select(0);
        }
    }

    setHeightOfListViewGrid() {
        let that = this;
        let windowHeight = $(window).height();
        let upperPartHeights = $("#nama-erp-header").outerHeight(true);
        if (that.presenter.wrapperHeight) {
            windowHeight = that.presenter.wrapperHeight;
            upperPartHeights = 0;
        }
        upperPartHeights += that.rootElement.find(".list-view-title").outerHeight(true);
        let h = windowHeight - upperPartHeights;
        let splitter = that.presenter.wrapperHeight ? that.presenter.embeddedListLayoutWrapper.find("#splitter") : that.rootElement.find("#splitter");
        splitter.css("height", h);
        if (that.presenter.wrapperHeight) {
            let children = [...splitter.children()];
            if (children && children.length)
                children.forEach(c => $(c).height(h));
        }
        that.rootElement.find("#gridAllVoice").css({height: h - this.calcToolbarHeight()});
        that.rootElement.find("#gridAllVoice").data("kendoGrid").resize();

    }

    calcToolbarHeight() {
        let toolbarHeight = this.rootElement.find(".list-screen-toolbar").outerHeight(true);
        let criteria = this.rootElement.find(".list-view-criteria");
        let criteriaHeight = criteria.is(":visible") ? criteria.outerHeight(true) : 0;
        return toolbarHeight + criteriaHeight;
    }

    showResultSettingsWindow() {
        let that = this;
        let layoutDisplayColumns = that.presenter.preferences.listLayout.displayColumns;
        let displayedColumns = [];
        let notDisplayedColumns = [];
        for (let col of layoutDisplayColumns) {
            if (col.displayed === true)
                displayedColumns.push(col);
            else
                notDisplayedColumns.push(col);
        }
        /**
         *
         * @type {namaTypes.NamaWindowBtnData}
         */
        let okBtnData = {
            btnTitle: "ok", btnAction: () => {
                let columns = [...listBox.find("#displayedColumns").data("kendoListBox").dataSource.data()];
                window.closeWindow();
                let layoutDisplayColumns = that.presenter.preferences.listLayout.displayColumns;
                let columnsIDs = columns.map((l) => l.id);
                for (let col of layoutDisplayColumns) {
                    if (columnsIDs.contains(col.id))
                        col.displayed = true;
                    else
                        col.displayed = false;
                }
                that.displayColumns = createListViewColumns(that, {displayColumns: layoutDisplayColumns}, that.model);
                initKendoGrid(that, "", gridId);
                that.presenter.onRefresh();
            }
        };
        /**
         *
         * @type {namaTypes.NamaWindowBtnData}
         */
        let cancelBtnData = {
            btnTitle: "cancel"
        };
        let window = new NamaKendoWindow(bf.resultSettings, okBtnData, cancelBtnData);
        window.width = "60%";
        window.height = "45%";
        if (isMobileDevice()) {
            window.width = "90%";
            window.height = "90%";
        }
        let listBox = $(ResultSettingsTemplate({
            translateId: ts.translateId
        }));
        window.content.append(listBox);
        window.showWindow();
        that.model_ = kendo.data.Model.define({});
        Object.defineProperty(that.model_.prototype, "$translatedFieldId", {
            enumerable: false, configurable: true, get: function () {
                return ts.translate(this.id, that.presenter.entityType)
            }, set: function (value) {
            }
        });
        listBox.find("#displayedColumns").kendoListBox({
            dataSource: new kendo.data.DataSource({
                data: displayedColumns,
                schema: {
                    model: that.model_
                }
            }),
            draggable: true,
            connectWith: "notDisplayedColumns",
            dropSources: ["notDisplayedColumns"],
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
            toolbar: {
                tools: ["transferTo", "transferFrom", "transferAllTo", "transferAllFrom"]
            }
        });

        listBox.find("#notDisplayedColumns").kendoListBox({
            dataSource: new kendo.data.DataSource({
                data: notDisplayedColumns,
                schema: {
                    model: that.model_
                }
            }),
            draggable: true,
            connectWith: "displayedColumns",
            dropSources: ["displayedColumns"],
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
        });
    }

    exportToExcel() {
        if (!userCan(this.presenter.entityType, CapabilityType.Export)) {
            notifier.showError(translateId("noAuthorityOnOperation"));
            return;
        }
        let that = this;
        let grid = that.kendoGrid();
        grid.saveAsExcel();
    }

    getSelectedRowsIndices() {
        let grid = this.kendoGrid();
        let selectedIndices = [];
        grid.select().each(function () {
            let rowData = grid.dataItem(this);
            let index = grid.dataSource.data().indexOf(rowData);
            if (!selectedIndices.contains(index))
                selectedIndices.push(index);
        });
        return selectedIndices;
    }

    getRowCount() {
        let that = this;
        let grid = that.kendoGrid();
        return grid.dataSource.data().length;
    }
}

export function showExportDialog(presenter) {
    let dialog = $(ReportExportDialogTemplate());
    let view = presenter.view.rootElement;
    if (!view)
        view = presenter.view;
    view.append(dialog);
    dialog.find("#exportAsPDF").click(() => presenter.onPrint(OutputFormat.PDF));
    dialog.find("#exportAsDOCX").click(() => presenter.onPrint(OutputFormat.DOCX));
    dialog.find("#exportAsRTF").click(() => presenter.onPrint(OutputFormat.RTF));
    dialog.find("#exportAsXLSX").click(() => presenter.onPrint(OutputFormat.XLSX));
    dialog.find("#exportAsXLS").click(() => presenter.onPrint(OutputFormat.XLS));
    dialog.find("#exportAsODT").click(() => presenter.onPrint(OutputFormat.ODT));
    dialog.find("#exportAsODS").click(() => presenter.onPrint(OutputFormat.ODS));
    dialog.find("#exportAsPPTX").click(() => presenter.onPrint(OutputFormat.PPTX));
    dialog.find("#sendEmailWithResult").click(() => presenter.sendEmail());
    dialog.find(".animate__animated").removeClass("d-none");
    dialog.find(".animate__animated").addClass("animate__zoomIn");
    dialog.find(".btn-close-printing").click(function () {
        dialog.find(".animate__animated").removeClass("animate__zoomIn");
        dialog.find(".animate__animated").addClass("d-none");
        dialog.remove();
    });
}

function preValidateListScreenToolbarButtons(that, toolbar, presenter) {
    if (that.presenter.preferences.listLayout.hideEntitySpecificFeatures) {
        toolbar.find("#newRecord").parent().css("display", "none");
        toolbar.find("#reviseBtn").parent().css("display", "none");
        toolbar.find("#unReviseBtn").parent().css("display", "none");
        toolbar.find("#deleteBtn").parent().css("display", "none");
        if (!that.alwaysShowTreeViewButton)
            toolbar.find("#treeViewBtn").parent().css("display", "none");
        else
            toolbar.find("#treeViewBtn").parent().css("display", "");
        return;
    }
    if (!userCanCreate(presenter.entityType))
        toolbar.find("#newRecord").addClass("k-disabled");
    else
        toolbar.find("#newRecord").removeClass("k-disabled");
    if (!userCan(presenter.entityType, CapabilityType.Revise))
        toolbar.find("#reviseBtn").addClass("k-disabled");
    else
        toolbar.find("#reviseBtn").removeClass("k-disabled");
    if (!userCan(presenter.entityType, CapabilityType.Unrevise))
        toolbar.find("#unReviseBtn").addClass("k-disabled");
    else
        toolbar.find("#unReviseBtn").removeClass("k-disabled");
    if (!presenter.supportsTreeInListView())
        toolbar.find("#treeViewBtn").addClass("k-disabled");
    else
        toolbar.find("#treeViewBtn").removeClass("k-disabled");
}

